import { forwardRef, ReactNode } from 'react';

import { HintVariant } from '../Hint.types';
import { Button } from '../../Button/Button';
import { Typography } from '../../Typography/Typography';

import { ICON_MAPPING } from './HintModal.const';

import styles from './HintModal.module.scss';

export interface HintModalProps {
  title?: string;
  message: ReactNode;
  variant?: HintVariant;
  dissmiss: () => void;
}

export const HintModal = forwardRef<HTMLDivElement, HintModalProps>(
  ({ title, variant, dissmiss, message }, ref) => {
    const content = (() => {
      if (typeof message === 'string') {
        return (
          <Typography variant="p1" align="center">
            {message}
          </Typography>
        );
      }
      return message;
    })();

    return (
      <div ref={ref} className={styles.root}>
        <div className={styles.header}>
          <Button
            size="s"
            icon="close"
            block={false}
            variant="text"
            onClick={dissmiss}
          />
        </div>
        <div className={styles.content}>
          <img alt="" src={ICON_MAPPING[variant]} className={styles.icon} />
          {!!title && (
            <Typography
              variant="h4"
              bold
              align="center"
              className={styles.title}
            >
              {title}
            </Typography>
          )}
          {content}
        </div>
        <div className={styles.actions}>
          <Button variant="primary" onClick={dissmiss}>
            Ok
          </Button>
        </div>
      </div>
    );
  }
);
